//  Copyright © Veeam Software Group GmbH

import { DataGrid, doubleToolbar } from '@veeam/components';
import React from 'react';

import type { Observable } from 'rxjs';

import { useEventsModel } from './hooks/useModel';
import { useSignalR } from './hooks/useEvent';
import { useDurationUpdate } from './hooks/useDurationUpdate';
import { useColumns } from './hooks/useColumns';
import { useFilter } from './hooks/useFilter';
import { useResources } from '../../../../infrastructure/resources';


import type { RestoreSessionId } from '../../../../services/restoreService';

export interface EventsGridProps {
    session: Observable<RestoreSessionId>;
}

export const EventsGrid: React.FC<EventsGridProps> = ({ session }) => {
    const resources = useResources().features.RestoreSessions.EventsGrid;
    const model = useEventsModel(session);
    const columns = useColumns(resources);
    const filters = useFilter(resources);

    useSignalR(model);

    useDurationUpdate(model);

    return (
        <DataGrid
            model={model}
            columns={columns}
            toolbar={{
                decorator: doubleToolbar(),
                items: [...filters],
            }}
            config={{
                canResizeColumns: true,
                columnsToggleable: true,
            }}
            texts={{
                empty: resources.emptyGridMessage,
            }}
        />
    );
};